import React from 'react';

/**
 * Simple "Team" dropdown used next to the assignee/report-to pickers.
 * Choosing a team doesn't assign anyone by itself -- it just narrows the
 * employee list the pickers next to it draw from, so a big employee
 * directory doesn't turn every assignment into a long scroll.
 */
const TeamSelect = ({ teams, teamId, onChange, disabled, id }) => (
  <select
    id={id}
    className="form-select"
    value={teamId || ''}
    onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
    disabled={disabled}
  >
    <option value="">All employees</option>
    {teams.map((t) => (
      <option key={t.id} value={t.id}>{t.name}</option>
    ))}
  </select>
);

export default TeamSelect;
